(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireccb9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireccb9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5HMOr", function(module, exports) {

var $gaPXN = parcelRequire("gaPXN");
const page = ()=>{
    if (document.querySelector("#iddapageexample")) return 0, $gaPXN.default;
    else return null;
};
if (!page()) return;
const app = Vue.createApp(page());
app.mount("#app");
window.instance = app;

});
parcelRegister("gaPXN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc65e35fb130017c$export$2e2bcd8739ae039; });
var $bc65e35fb130017c$export$2e2bcd8739ae039 = {
    data () {
        return {};
    },
    delimiters: [
        "{*",
        "*}"
    ]
};

});



parcelRequire("5HMOr");
})();
//# sourceMappingURL=index.js.map
